import { types } from "../types/types";

export const terminadosReducer = (state = {}, action) => {
  switch (action.type) {
    case types.setTerminado:
      return {
        ...state,
        ...action.payload,
      };

      case types.cleanTerminados:
        return {}

    default:
      return state;
  }
};
